import React, {Component} from 'react';
import {gpn} from "../GPN"
import req from "../req";
import config from "../config";
import ModalLoading from "../sections/ModalLoading";
import SignatureCanvas from "react-signature-canvas";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";

class Services extends Component {

    state = {
        services: [],
        selectedServices: [],

        servicesNote: "توجه داشته باشید که پس از تأیید و پرداخت، امکان لغو یا عودت هزینه پرداختی میسر نمی باشد.",

        loading: true
    };

    constructor() {
        super();
        this.sigCanvas = React.createRef();
    }


    componentDidMount() {
        this.getServices();
        this.getServicesNote();
    }

    getServices() {
        req.getRequest(`${config.api}/user/service2`)
            .then(r => {
                this.setState({
                    services: r,
                    loading: false
                });
            })
            .catch(err => {
                this.setState({
                    loading: false
                });
            });
    }

    getServicesNote() {
        req.getRequest(`${config.api}/user/services-note`)
            .then(r => {
                let {note} = r;
                note = note ? note.toString().trim() : "";

                if (note !== "") {
                    this.setState({
                        servicesNote: note
                    });
                }

            })
            .catch(err => {
            });
    }

    isActive(id = "") {
        id = id ? id.toString().trim() : "";
        let {selectedServices} = this.state;

        let ia = false;

        selectedServices?.map(s => {
            if (s._id.toString().trim() === id) {
                ia = true;
            }
        });

        return ia;
    }

    handleItemClick(s = null) {
        let {selectedServices} = this.state;

        let index = -1;

        selectedServices?.map((ss, i) => {
            if (s._id.toString().trim() === ss._id.toString().trim()) {
                index = i;
            }
        });

        if (index === -1) {
            selectedServices.push(s);
        } else {
            selectedServices.splice(index, 1);
        }

        this.setState({selectedServices});
    }

    getSum() {
        let {selectedServices} = this.state;
        let sum = 0;
        selectedServices?.map(s => {
            let {price} = s;
            price = price ? price : 0;
            if (typeof price === "string") {
                price = Number(price.toString().trim())
            }
            sum = sum + price;
        });

        return sum;
    }

    submit() {
        let {services} = this.state;
        services = services ? services : [];

        let signature = this.sigCanvas.current.toDataURL("image/png");

        let error = "";

        if (services.length === 0 && error === "") {
            error = "خدمات را انتخاب کنید!";
        }
        if (this.sigCanvas.current.isEmpty() && error === "") {
            error = "امضای خود را ثبت کنید";
        }

        if (error === "") {
            this.setState({loading: true});
            req.postRequest(`${config.api}/user/service2`, {services, signature})
                .then(r => {
                    if (r) {
                        let {url} = r;
                        url = url ? url : "";
                        if (url !== "") {
                            try {
                                document.location.href = url;
                            } catch (err) {
                            }
                        } else {
                            toast.error("خطا!");
                        }
                    } else {
                        toast.error("خطا!");
                    }
                    this.setState({loading: false});
                })
                .catch(err => {
                    toast.error("خطا!");
                    this.setState({loading: false});
                });
        } else {
            toast.error(error);
        }
    }

    render() {
        let {services, selectedServices, loading, servicesNote} = this.state;
        let canvasWidth = 150;
        try {
            canvasWidth = document.getElementById('parent').offsetWidth - 40;
        } catch (err) {
        }

        let sum = 0;
        try {
            sum = this.getSum();
        } catch (err) {
        }
        return (
            <div className="services2">
                <ModalLoading loading={loading}/>
                <h1>انتخاب خدمات</h1>

                <div className="list">
                    {services?.map((s, i) =>
                        <article key={"service" + i}
                                 onClick={() => this.handleItemClick(s)}
                                 className={this.isActive(s._id) ? "active" : ""}>
                            <div className="row justify-content-between">
                                <p className="title">{s.title}</p>
                                <p className="price">
                                    <span>هزینه عملیات:</span><span>{config.priceFormatter(s.price)}&nbsp;تومان</span>
                                </p>
                            </div>
                        </article>
                    )}
                </div>

                {selectedServices?.length > 0 ?
                    <>
                        <br/>
                        <div className="line">
                        </div>
                        <div className="checkout">
                            <div className="selected">
                                <div className="row">
                                    <div className="col">
                                        {selectedServices?.map((ss, i) =>
                                            <span
                                                className="title"
                                                key={"ss" + i}>{ss.title}{selectedServices.length - 1 !== i ?
                                                <span className="plus">+</span> : null}</span>
                                        )}
                                    </div>
                                    <div className="col-auto">
                                        <div className="sum">
                                            <span>قابل پرداخت:</span><span>{config.priceFormatter(sum)}&nbsp;تومان</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    : null}

                {selectedServices?.length > 0 ?
                    <>
                        <p className="note">
                            {servicesNote}
                        </p>
                        <div className="signature">
                            <p className="label">امضای خود را ثبت کنید</p>
                            <SignatureCanvas penColor='black'
                                             ref={this.sigCanvas}
                                             canvasProps={{
                                                 className: 'signature-canvas',
                                                 width: canvasWidth, height: 250
                                             }}/>

                            <span className="clear"
                                  onClick={() => this.sigCanvas.current.clear()}>پاک کردن امضاء</span>

                        </div>

                    </>
                    : null}

                {
                    selectedServices?.length > 0 ?
                        <div>
                            <Button
                                backgroundColor="#008000"
                                icon="check"
                                onClick={() => this.submit()}>تأیید و پرداخت</Button>
                        </div>
                        : null
                }
            </div>
        );
    }
}

export default gpn(Services);